import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
// NOTE: Icon set kept for future use when re-enabling custom icons
// import { CheckCircle2, Info, AlertTriangle, XCircle, Loader2 } from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const { className, toastOptions, style, ...rest } = props;

  const mergedToastOptions: ToasterProps["toastOptions"] = {
    ...(toastOptions ?? {}),
    classNames: {
      ...(toastOptions?.classNames ?? {}),
      default: cn("cfl-toast-default", toastOptions?.classNames?.default),
      success: cn("cfl-toast-success", toastOptions?.classNames?.success),
      error: cn("cfl-toast-error", toastOptions?.classNames?.error),
      warning: cn("cfl-toast-warning", toastOptions?.classNames?.warning),
    },
  };

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className={cn("toaster group", className)}
      toastOptions={mergedToastOptions}
      /*
       * Icon override pattern (kept for future use):
       * Uncomment this block to restore custom default icons.
       */
      // icons={{
      //   success: props.icons?.success ?? <CheckCircle2 className="size-4" />,
      //   info: props.icons?.info ?? <Info className="size-4" />,
      //   warning: props.icons?.warning ?? (
      //     <AlertTriangle className="size-4" />
      //   ),
      //   error: props.icons?.error ?? <XCircle className="size-4" />,
      //   loading: props.icons?.loading ?? (
      //     <Loader2 className="size-4 animate-spin" />
      //   ),
      //   close: props.icons?.close ?? <X className="size-4" />,
      // }}
      /*
       * Disable leading icons globally for now. Close icon stays.
       */
      icons={{
        success: null,
        info: null,
        warning: null,
        error: null,
        loading: null,
        close: props.icons?.close ?? <X className="size-4" />,
      }}
      style={{
        ...(style as React.CSSProperties),
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        fontFamily: '"m6x11", sans-serif',
      } as React.CSSProperties}
      {...rest}
    />
  );
};

export { Toaster };
